import { render, staticRenderFns } from "./LocationsEdit.vue?vue&type=template&id=a9fe589c&lang=pug"
import script from "./LocationsEdit.vue?vue&type=script&lang=ts"
export * from "./LocationsEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports